<template>
    <button
        ref="buttonEl"
        v-qa="'filter-button'"
        class="filter-button"
        :class="classButton"
        type="button"
        @click="openFilterModal"
    >
        <Icon icon="filters-alt-2" />

        <span
            v-if="count"
            class="count"
            :data-qa-active-filter-count="count"
        >
            {{ count }}
        </span>

        {{ t('catalogue.grid.filter') }}
    </button>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'

import { useFilterButton } from './useFilterButton'

import Icon from '@/components/ui/icon/Icon.vue'

const { buttonStyle = 'solid' } = defineProps<{
    buttonStyle?: 'solid' | 'text'
}>()

const buttonEl = useTemplateRef<HTMLButtonElement>('buttonEl')
defineExpose({ buttonEl })

const { count, openFilterModal } = useFilterButton()

const classButton = computed(() => ({
    [buttonStyle]: true,
}))

const { t } = useI18n()
</script>

<style scoped lang="scss">
.filter-button {
    position: relative;
    margin-right: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: 500;
    background-color: $blue;
    border-radius: 10px;
    color: $white;
    padding-right: 12px;

    .icon {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        vertical-align: top;

        font-size: 18px;
        color: $white;
        border-radius: 50%;
    }

    .count {
        position: absolute;
        top: -4px;
        right: -4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: $red;
        color: $white;
        width: 16px;
        height: 16px;
    }

    &.text {
        background-color: $white;
        color: $slate;

        .icon {
            color: $slate;
        }
    }
}
</style>
